// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"full_width_promo-module--wrapper--18Sti"};